import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LegalAcknowledgementService {
  private readonly http = inject(HttpClient);
  getAcknowledgementDetails(
    acknowledgementType: string,
    participantId: string,
  ): Observable<LegalAcknowledgement> {
    const url = `/api/legal-acknowledgements/${acknowledgementType}/participant/${participantId}`;
    return this.http.get<LegalAcknowledgementDto>(url).pipe(
      map((dto) => ({
        type: dto.type,
        content: dto.htmlContent,
      })),
    );
  }

  acceptAcknowledgements(
    participantId: string,
    acknowledgementTypes: string[],
  ): Observable<{ success: boolean; message: string }> {
    return this.http
      .post<void>(`/api/legal-acknowledgements`, {
        participantId,
        acknowledgementTypes,
      })
      .pipe(
        map(() => ({
          success: true,
          message: 'Acknowledgements submitted successfully',
        })),
      );
  }
}

interface LegalAcknowledgementDto {
  type: string;
  htmlContent: string;
}

export interface LegalAcknowledgement {
  type: string;
  content: string;
}
